import { useRouter } from 'next/compat/router';
import React from 'react';

import { type LexSlug, useLex } from '../../context/LexContext';
import { useOnce } from '../../utils/hooks/useOnce';

type Props = React.PropsWithChildren<{
  lex: LexSlug;
  redirectUrl?: string;
  overrideIsRamped?: boolean;
}>;

const LexGuardedPage: React.FC<Props> = ({
  lex,
  redirectUrl = '/',
  overrideIsRamped,
  children,
}) => {
  const router = useRouter();
  const { isLexEnabled, isLexLoading } = useLex();

  useOnce(async () => {
    if (!isLexEnabled(lex) && !overrideIsRamped) {
      await router?.replace(redirectUrl);
    }
  }, !isLexLoading);

  return <>{children}</>;
};

export default LexGuardedPage;
